<template>
  <base-section id="map" space="0">
    <iframe
      allowfullscreen
      aria-hidden="false"
      frameborder="0"
      height="500"
      src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1994.3665685345543!2d103.91749278972529!3d1.3363568984900558!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31da3d5a293e9f97%3A0x8499bfd66faf6a43!2s703%20Bedok%20Reservoir%20Rd%2C%2001%203510%2C%20Singapore%20470703!5e0!3m2!1sen!2slk!4v1636814276960!5m2!1sen!2slk"
      style="border:0; display: block;"
      tabindex="0"
      width="100%"
    />
  </base-section>
</template>

<script>
export default {
  name: "SectionMap",

  provide: {
    heading: { align: "center" }
  }
};
</script>
